import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _styled from "styled-components";
import { useState, useRef, useCallback, useEffect, useMemo } from 'react';
import { Combobox as BaseCombobox } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/24/solid';
import { useOnClickOutside } from 'usehooks-ts';
import { useTranslation } from 'next-i18next';
import { Spinner } from '../spinner';
import { selectLabelStyle, selectSecondaryLabelStyle, SelectMainWrapper, selectInteractiveAreaStyle, ArrowIconWrapper, selectInteractiveAreaContentStyle, selectOptionsStyle, StyledSelectHelperText } from './select.styled';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function Combobox(_ref) {
  var value = _ref.value,
      _onChange = _ref.onChange,
      dropdownList = _ref.dropdownList,
      placeholder = _ref.placeholder,
      inputWrapperStyle = _ref.inputWrapperStyle,
      listStyle = _ref.listStyle,
      inputStyle = _ref.inputStyle,
      noOptionsMessage = _ref.noOptionsMessage,
      error = _ref.error,
      isLoading = _ref.isLoading,
      onQueryChange = _ref.onQueryChange,
      disabled = _ref.disabled,
      label = _ref.label,
      secondaryLabel = _ref.secondaryLabel,
      fullwidth = _ref.fullwidth,
      _ref$autoCompleteOff = _ref.autoCompleteOff,
      autoCompleteOff = _ref$autoCompleteOff === void 0 ? true : _ref$autoCompleteOff,
      _ref$showIcon = _ref.showIcon,
      showIcon = _ref$showIcon === void 0 ? true : _ref$showIcon,
      _ref$noFilter = _ref.noFilter,
      noFilter = _ref$noFilter === void 0 ? false : _ref$noFilter,
      _ref$helperText = _ref.helperText;
  _ref$helperText = _ref$helperText === void 0 ? {
    variant: 'error',
    message: ''
  } : _ref$helperText;
  var helperTextVariant = _ref$helperText.variant,
      helperTextMessage = _ref$helperText.message;

  var _useTranslation = useTranslation('common'),
      translateCommon = _useTranslation.t;

  var _useState = useState(''),
      query = _useState[0],
      setQuery = _useState[1];

  var _useState2 = useState(false),
      isDropdownOpen = _useState2[0],
      setIsDropdownOpen = _useState2[1];

  var dropdownRef = useRef(null);
  var filteredOptions = query === '' || noFilter ? dropdownList : dropdownList === null || dropdownList === void 0 ? void 0 : dropdownList.filter(function (v) {
    return v.toLowerCase().includes(query.toLowerCase());
  });
  useOnClickOutside(dropdownRef, function () {
    setIsDropdownOpen(false);
  }, 'mousedown');
  var handleChange = useCallback(function (event) {
    var inputValue = event.target.value;
    setQuery(inputValue);

    if (inputValue === '') {
      _onChange && _onChange('');
    }

    setIsDropdownOpen(true);
  }, [_onChange, setQuery]);
  var optionsListEl = useMemo(function () {
    return isLoading ? /*#__PURE__*/_jsx(SpinnerWrapper, {
      children: /*#__PURE__*/_jsx(_StyledSpinner, {
        color: "primary",
        size: "sm"
      })
    }) : filteredOptions !== null && filteredOptions !== void 0 && filteredOptions.length ? /*#__PURE__*/_jsx(DropdownStyled, {
      as: "ul",
      ref: dropdownRef,
      fullwidth: fullwidth,
      twStyle: listStyle,
      children: filteredOptions !== null && filteredOptions !== void 0 && filteredOptions.length ? filteredOptions === null || filteredOptions === void 0 ? void 0 : filteredOptions.map(function (v) {
        return /*#__PURE__*/_jsx(BaseCombobox.Option, {
          value: v,
          onClick: function onClick() {
            return setIsDropdownOpen(false);
          },
          as: "li",
          className: "rounded-lg px-0 py-0 lg:(px-0 py-0) relative h-12 flex items-center",
          children: function children(_ref2) {
            var active = _ref2.active;
            return /*#__PURE__*/_jsx(StyledComboboxOption, {
              active: active,
              children: v
            });
          }
        }, v);
      }) : /*#__PURE__*/_jsx(BaseCombobox.Option, {
        value: "",
        onClick: function onClick() {
          return setIsDropdownOpen(false);
        },
        children: noOptionsMessage || "-- ".concat(translateCommon('no_options_loaded'), " --")
      })
    }) : query ? /*#__PURE__*/_jsx(DropdownStyled, {
      as: "ul",
      ref: dropdownRef,
      fullwidth: fullwidth,
      twStyle: listStyle,
      children: /*#__PURE__*/_jsx(BaseCombobox.Option, {
        value: "",
        onClick: function onClick() {
          return setIsDropdownOpen(false);
        },
        children: noOptionsMessage || "-- ".concat(translateCommon('no_options_loaded'), " --")
      })
    }) : null;
  }, [filteredOptions, fullwidth, isLoading, listStyle, noOptionsMessage, query, translateCommon]);
  useEffect(function () {
    onQueryChange && onQueryChange(query);
  }, [onQueryChange, query]);
  return /*#__PURE__*/_jsxs(SelectMainWrapper, {
    fullwidth: fullwidth,
    children: [/*#__PURE__*/_jsxs(BaseCombobox, {
      value: value,
      onChange: function onChange(option) {
        var value = option || '';
        _onChange && _onChange(value);
        setIsDropdownOpen(false);
      },
      disabled: disabled,
      children: [label && /*#__PURE__*/_jsxs(StyledComboboxLabel, {
        disabled: disabled,
        children: [/*#__PURE__*/_jsx("span", {
          children: label
        }), " ", /*#__PURE__*/_jsx(StyledSecondaryLabel, {
          children: secondaryLabel
        })]
      }), /*#__PURE__*/_jsxs(InputContainer, {
        fullwidth: fullwidth,
        twStyle: inputWrapperStyle,
        children: [/*#__PURE__*/_jsx(StyledInput, {
          onClick: function onClick() {
            return setIsDropdownOpen(true);
          },
          onChange: handleChange,
          displayValue: function displayValue(value) {
            return value;
          },
          placeholder: placeholder,
          isError: !!error,
          disabled: disabled,
          twStyle: inputStyle,
          autoComplete: autoCompleteOff ? 'off' : undefined
        }), showIcon && /*#__PURE__*/_jsx(_StyledArrowIconWrapper, {
          isOpen: isDropdownOpen,
          children: /*#__PURE__*/_jsx(_StyledChevronDownIcon, {})
        })]
      }), /*#__PURE__*/_jsx(InputContainer, {
        fullwidth: fullwidth,
        twStyle: inputWrapperStyle,
        children: isDropdownOpen && optionsListEl
      })]
    }), helperTextMessage && /*#__PURE__*/_jsx(StyledSelectHelperText, {
      variant: helperTextVariant,
      children: helperTextMessage
    })]
  });
}
export default Combobox;

var InputContainer = /*#__PURE__*/_styled.div.withConfig({
  displayName: "selectcombobox__InputContainer",
  componentId: "sc-f13310-0"
})(["", " ", " ", ""], {
  "position": "relative"
}, function (_ref3) {
  var fullwidth = _ref3.fullwidth;
  return fullwidth ? {
    "maxWidth": "100%"
  } : {
    "maxWidth": "320px"
  };
}, function (_ref4) {
  var twStyle = _ref4.twStyle;
  return twStyle || {};
});

var DropdownStyled = /*#__PURE__*/_styled(function (props) {
  return /*#__PURE__*/_jsx(BaseCombobox.Options, _objectSpread({}, props));
}).withConfig({
  displayName: "selectcombobox__DropdownStyled",
  componentId: "sc-f13310-1"
})(["", ";", ";li{", ";}", " ", ""], selectOptionsStyle, {
  "listStyleType": "none",
  "paddingTop": "0.5rem",
  "paddingBottom": "0.5rem",
  "--tw-text-opacity": "1",
  "color": "rgb(55 65 81 / var(--tw-text-opacity))"
}, {
  "position": "relative",
  "userSelect": "none",
  "paddingLeft": "1rem",
  "paddingRight": "1rem",
  "paddingTop": "0.5rem",
  "paddingBottom": "0.5rem",
  "textAlign": "left",
  ":hover": {
    "cursor": "pointer",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(243 244 246 / var(--tw-bg-opacity))"
  }
}, function (_ref5) {
  var fullwidth = _ref5.fullwidth;
  return fullwidth ? {
    "maxWidth": "100%"
  } : {
    "maxWidth": "320px"
  };
}, function (_ref6) {
  var twStyle = _ref6.twStyle;
  return twStyle || {};
});

var StyledInput = /*#__PURE__*/_styled(function (props) {
  return /*#__PURE__*/_jsx(BaseCombobox.Input, _objectSpread({}, props));
}).withConfig({
  displayName: "selectcombobox__StyledInput",
  componentId: "sc-f13310-2"
})(["", ";", " ", " ", " ", ";"], [selectInteractiveAreaStyle, selectInteractiveAreaContentStyle], {
  "overflow": "hidden",
  "textOverflow": "ellipsis",
  "whiteSpace": "nowrap",
  "paddingRight": "3rem",
  "::placeholder": {
    "fontSize": "1rem",
    "lineHeight": "1.5rem",
    "fontWeight": "400",
    "--tw-text-opacity": "1",
    "color": "rgb(102 102 118 / var(--tw-text-opacity))"
  },
  ":focus": {
    "--tw-border-opacity": "1",
    "borderColor": "rgb(117 117 131 / var(--tw-border-opacity))",
    "outline": "2px solid transparent",
    "outlineOffset": "2px",
    "--tw-ring-offset-shadow": "var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color)",
    "--tw-ring-shadow": "var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color)",
    "boxShadow": "var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000)"
  },
  ":active": {
    "--tw-border-opacity": "1",
    "borderColor": "rgb(117 117 131 / var(--tw-border-opacity))",
    "outline": "2px solid transparent",
    "outlineOffset": "2px",
    "--tw-ring-offset-shadow": "var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color)",
    "--tw-ring-shadow": "var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color)",
    "boxShadow": "var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000)"
  }
}, function (_ref7) {
  var disabled = _ref7.disabled;
  return disabled ? {
    "cursor": "not-allowed",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(222 222 225 / var(--tw-bg-opacity))",
    ":hover": {
      "--tw-bg-opacity": "1",
      "backgroundColor": "rgb(222 222 225 / var(--tw-bg-opacity))"
    }
  } : {};
}, function (_ref8) {
  var twStyle = _ref8.twStyle;
  return twStyle || {};
}, function (_ref9) {
  var isError = _ref9.isError;
  return isError ? {
    "borderStyle": "none",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(250 230 233 / var(--tw-bg-opacity))",
    "outlineColor": "#e88a99"
  } : {};
});

var SpinnerWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "selectcombobox__SpinnerWrapper",
  componentId: "sc-f13310-3"
})(["", ""], {
  "display": "flex",
  "width": "100%",
  "alignItems": "center",
  "justifyContent": "center",
  "padding": "0.25rem"
});

var StyledComboboxLabel = /*#__PURE__*/_styled(BaseCombobox.Label).withConfig({
  displayName: "selectcombobox__StyledComboboxLabel",
  componentId: "sc-f13310-4"
})(["", " ", ""], selectLabelStyle, function (_ref10) {
  var disabled = _ref10.disabled;
  return disabled ? {
    "--tw-text-opacity": "1",
    "color": "rgb(117 117 131 / var(--tw-text-opacity))"
  } : {};
});

var StyledSecondaryLabel = /*#__PURE__*/_styled.span.withConfig({
  displayName: "selectcombobox__StyledSecondaryLabel",
  componentId: "sc-f13310-5"
})(["", ""], selectSecondaryLabelStyle);

var StyledComboboxOption = /*#__PURE__*/_styled.span.withConfig({
  displayName: "selectcombobox__StyledComboboxOption",
  componentId: "sc-f13310-6"
})(["", " ", ""], {
  "width": "100%",
  "overflow": "hidden",
  "textOverflow": "ellipsis",
  "whiteSpace": "nowrap",
  "fontSize": "1rem",
  "lineHeight": "1.5rem",
  "fontWeight": "500",
  "--tw-text-opacity": "1",
  "color": "rgb(28 28 51 / var(--tw-text-opacity))"
}, function (_ref11) {
  var active = _ref11.active;
  return active ? {
    "position": "absolute",
    "top": "0px",
    "left": "0px",
    "right": "0px",
    "bottom": "0px",
    "display": "flex",
    "height": "100%",
    "width": "100%",
    "alignItems": "center",
    "borderRadius": "0.5rem",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(235 235 237 / var(--tw-bg-opacity))",
    "paddingLeft": "1rem",
    "paddingRight": "1rem"
  } : {};
});

var _StyledSpinner = /*#__PURE__*/_styled(Spinner).withConfig({
  displayName: "selectcombobox___StyledSpinner",
  componentId: "sc-f13310-7"
})({
  "marginLeft": "auto",
  "marginRight": "auto"
});

var _StyledArrowIconWrapper = /*#__PURE__*/_styled(ArrowIconWrapper).withConfig({
  displayName: "selectcombobox___StyledArrowIconWrapper",
  componentId: "sc-f13310-8"
})({
  "position": "absolute",
  "top": "13px",
  "right": "1rem"
});

var _StyledChevronDownIcon = /*#__PURE__*/_styled(ChevronDownIcon).withConfig({
  displayName: "selectcombobox___StyledChevronDownIcon",
  componentId: "sc-f13310-9"
})({
  "height": "1.5rem",
  "width": "1.5rem",
  "--tw-text-opacity": "1",
  "color": "rgb(28 28 51 / var(--tw-text-opacity))"
});